import { format } from 'date-fns';
export const getDateWithTime = (date: Date) => {
  return format(date, 'h:mm MM/dd/yyyy');
};

export const getFormalDate = (date: Date) => {
  return format(date, 'MMMM dd yyyy');
};

export const getFormalDateShort = (date: Date) => {
  return format(date, 'MM/dd/yyyy');
};

export const getScheduleDateWithTime = (date: Date) => {
  return format(date, "do MMM ''yy (h:mma)");
};

export const getScheduleTime = (date: Date) => {
  return format(date, 'h:mm a');
};
